import { BrandsList } from './BrandsList';

export default BrandsList;
